import React, { PropsWithChildren } from "react";
import styles from "./ProductContainer.module.scss";

interface ProductContainerProps {}

export const ProductContainer: React.FC<
  ProductContainerProps & PropsWithChildren
> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};
